import './assets/css/style.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import './assets/css/theincircle-font.css'
import './assets/css/employer-dashboard.css'
import './assets/css/employee.css'
import './registerServiceWorker'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import VOtpInput from 'vue3-otp-input'
import { createHead } from '@vueuse/head'
const head = createHead()
const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(store)
app.use(ElementPlus)
app.use(head)
app.component('v-otp-input', VOtpInput)
app.mount('#app')

import 'bootstrap/dist/js/bootstrap.min.js'
